module.exports = __webpack_public_path__ + "img/logo_white.69110fec.png";